export default __webpack_public_path__ + "static/media/gaetano-parisio.9bc6b836.jpg";